export const defaultElementData = {
    nodeInfo: { // 节点信息
        desc: '',
        execLog: 0, // 查看流程图
        dueDate: '', // 任务到期时间
        difficultScore: 1 // 任务难度分
    },
    executor: { // 执行人
        execType: 0, // 节点任务执行方式
        modeType: 0, // 执行人选取方式
        executors: [] // 执行人
    },
    dataOperate: { // 数据操作
        operateType: 0, // 操作方式
        dataSource: '', // 目标数据来源
        formId: '' // 已经选择的自定义表单
    }
};



// WEBPACK FOOTER //
// ./src/pages/process/MyProcess/defaultData.js